import brandImage from '../assets/sweetlisteners-brandImage-1500.png';
import {
  BRAND_BLUSH,
  BRAND_CTA,
  BRAND_CTA_HOVER,
  BRAND_ROSE,
  BRAND_ROSE_HOVER,
} from '../util/brandPalette';

/////////////////////////////////////////////////////////
// Locked homepage palette. Console hosted teal/green must not override.
// Pink #F51F79, blue #159BE8, cream #FFFDFC, navy #0B2B5B.
/////////////////////////////////////////////////////////

export const marketplaceColor = BRAND_ROSE;
export const marketplaceColorDark = BRAND_ROSE_HOVER;
export const marketplaceColorLight = BRAND_BLUSH;

export const colorPrimaryButton = BRAND_CTA;
export const colorPrimaryButtonDark = BRAND_CTA_HOVER;
export const colorPrimaryButtonLight = BRAND_BLUSH;

export const logoImageDesktopURL = '/static/branding/sweet-listeners-original-logo.png';
export const logoImageMobileURL = '/static/branding/sweet-listeners-original-logo.png';
export const loginBackgroundImageUrl = '/static/login-sofa-bg.jpg';

export const logoSettings = {
  height: 48,
  format: 'image',
};

export const brandImageURL = brandImage;

// Stable public path so OG/Twitter tags can use https://sweetlisteners.com/...
export const facebookImageURL = '/static/og/sweet-listeners-share-1200x630.png';
export const twitterImageURL = '/static/og/sweet-listeners-share-1200x630.png';
